import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging"; // 👈 获取推送能力

// 这是你的巴拿马云端配置
const firebaseConfig = {
  apiKey: "AIzaSyABEuqumkvh0xsdQgZ2IGAtE8E0S3rrrRU",
  authDomain: "fixbox-app-51db9.firebaseapp.com",
  projectId: "fixbox-app-51db9",
  storageBucket: "fixbox-app-51db9.firebasestorage.app",
  messagingSenderId: "1087887329272",
  appId: "1:1087887329272:web:f344bacec56f9e386eb80d",
  measurementId: "G-T81D7Q7C1S"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);      // 👈 帮您加回了缺失的 db
const auth = getAuth(app);         // 👈 帮您加回了缺失的 auth
const storage = getStorage(app);
const messaging = getMessaging(app);

// 统一导出给 App.js 使用
export { app, db, auth, storage, messaging };